import { createBrowserRouter, type RouteObject } from 'react-router-dom';
import { ProtectedRoute } from './components/auth/protected-route';
import { AuthLayout } from './layouts/auth-layout';
import { DashboardLayout } from './layouts/dashboard-layout';
import { RootLayout } from './layouts/root-layout';
import { DashboardPage } from './pages/dashboard';
import { BillingPage } from './pages/dashboard/billing';
import { ConnectedClientsPage } from './pages/dashboard/connected-clients';
import { ContactsPage } from './pages/dashboard/contacts';
import { ContactDetailsPage } from './pages/dashboard/contacts/[id]';
import { NewContactPage } from './pages/dashboard/contacts/new';
import { JobsPage } from './pages/dashboard/jobs';
import { JobDetailsPage } from './pages/dashboard/jobs/[id]';
import { MonitorsPage } from './pages/dashboard/monitors';
import { MonitorDetailsPage } from './pages/dashboard/monitors/[id]';
import { MonitorResultsPage } from './pages/dashboard/monitors/[id]/results';
import { EditMonitorPage } from './pages/dashboard/monitors/edit';
import { NewMonitorPage } from './pages/dashboard/monitors/new';
import { EmailPreferencePage } from './pages/email-preference';
import { HomePage } from './pages/home';
import { LoginPage } from './pages/login';
import { OAuthConsentPage } from './pages/oauth-consent';
import { RegisterPage } from './pages/register';
import { ResetPasswordPage } from './pages/reset-password';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <RootLayout />,
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: 'email-preferences/unsubscribe/:token',
        element: <EmailPreferencePage purpose="unsubscribe" />,
      },
      {
        path: 'unsubscribe/:token',
        element: <EmailPreferencePage purpose="unsubscribe" />,
      },
      {
        path: 'resubscribe/:token',
        element: <EmailPreferencePage purpose="resubscribe" />,
      },
      {
        path: 'email-preferences/resubscribe/:token',
        element: <EmailPreferencePage purpose="resubscribe" />,
      },
      {
        path: '/',
        element: <AuthLayout />,
        children: [
          {
            path: 'login',
            element: <LoginPage />,
          },
          {
            path: 'register',
            element: <RegisterPage />,
          },
          {
            path: 'reset-password',
            element: <ResetPasswordPage />,
          },
        ],
      },
      { path: 'oauth/consent', element: <OAuthConsentPage /> },
      {
        path: 'dashboard',
        element: (
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        ),
        children: [
          {
            index: true,
            element: <DashboardPage />,
          },
          {
            path: 'monitors',
            children: [
              {
                index: true,
                element: <MonitorsPage />,
              },
              {
                path: 'new',
                element: <NewMonitorPage />,
              },
              {
                path: 'edit',
                element: <EditMonitorPage />,
              },
              {
                path: ':id',
                element: <MonitorDetailsPage />,
              },
              {
                path: ':id/results',
                element: <MonitorResultsPage />,
              },
            ],
          },
          {
            path: 'jobs',
            children: [
              { index: true, element: <JobsPage /> },
              { path: ':id', element: <JobDetailsPage /> },
            ],
          },
          {
            path: 'contacts',
            children: [
              {
                index: true,
                element: <ContactsPage />,
              },
              {
                path: 'new',
                element: <NewContactPage />,
              },
              {
                path: ':id',
                element: <ContactDetailsPage />,
              },
            ],
          },
          {
            path: 'connected-clients',
            element: <ConnectedClientsPage />,
          },
          {
            path: 'billing',
            element: <BillingPage />,
          },
        ],
      },
    ],
  },
];

export const router: ReturnType<typeof createBrowserRouter> = createBrowserRouter(routes);
